import { Archive } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { isBranchScopedPath } from '@/components/layout/isBranchScopedPath';
import { useT } from '@/contexts/I18nContext';
import { useCurrentZone } from '@/hooks/useCurrentZone';

/** Тонкая полоса под шапкой на страницах филиала, если он в архиве (AI14):
 *  объясняет, почему данные есть, а включить анализ нельзя. */
export function ArchivedZoneNotice() {
  const { t } = useT();
  const location = useLocation();
  const { currentZone } = useCurrentZone();
  if (!currentZone?.is_archived || !isBranchScopedPath(location.pathname)) return null;
  return (
    <div className="flex shrink-0 items-center gap-2 border-b border-border bg-muted px-4 py-1.5 text-xs text-muted-foreground">
      <Archive className="size-3.5 shrink-0" />
      <span className="min-w-0">{t('layout.archivedNotice')}</span>
    </div>
  );
}
